
  <div>
    <app-email-login *ngIf="loaded"></app-email-login>
  </div>
  <!-- <div>
    <app-signout></app-signout>
  </div> -->
